/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { getAllSupportedIndexes, supportedGauges } from '../helpers/supportedContracts';
export var ClaimableReward = createPlugin({
    protocol: 'CURVE',
    type: 'GETTER',
    method: 'claimable_reward',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_gauge',
                    options: supportedGauges.filter(function (pool) { return pool.chainId === Number(chainId); }),
                }),
                methodParams: {
                    user: new FctAddress({}),
                    rewardToken: new FctAddress({ destination: 'erc20', options: getAllSupportedIndexes(chainId) }),
                },
            },
            output: {
                amount: new FctValue({ innerIndex: 0, destination: 'wei_amount' }),
            },
        });
    },
});
